import React, { useState } from 'react'
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import ShareModal from "../../molecules/share-modal/shareModal";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import './headboardVideo.scss'

const HeadboardVideo = (props: ReferenciaCabecera) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const getCurrentPage = () => {
        const arr = props[0].migaDePan.split("/");
        return arr[arr.length - 1].trim();
      }

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    let videoUrl = props[0].redireccionBoton.includes('youtube') ? props[0].redireccionBoton + '?rel=0' : props[0].redireccionBoton
    videoUrl = "https://www.youtube.com/embed/znFdI7vro0g"

    return(
        <div className='o-headboard-video'>
            <div className='o-headboard-video__breadcrumb hide-on-mobile'>
                <Breadcrumb content={`${props[0].migaDePan}`} />
            </div>

            <div className='o-headboard-video__title'>
                <h2 className='o-headboard-video__title-title'>{props[0].tituloPrincipal}</h2>
            </div>

            <div className='o-headboard-video__date'>
                <p className='o-headboard-video__date-date'>{props[0].tituloSpan}</p>
            </div>

            <div className='o-headboard-video__info'>
                <div className='o-headboard-video__info-video'>
                    <iframe width="100%" height="100%" src={videoUrl} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>
                
                <div className='o-headboard-video__info-container'>
                    <div className='o-headboard-video__info-container__description'>
                        {documentToReactComponents(props[0].descripcion.json)}
                    </div>

                    <div className='o-headboard-video__info-container__icons'>
                        <div className='o-headboard-video__info-container__icons-share'>
                            <p className={`icon-share gtm${normalizeTwoWords(getCurrentPage())}Banner${normalizeTwoWords(props[0].tituloPrincipal)}Compartir`}></p>
                            <p
                            className='o-headboard-video__info-container__icons-share__text'
                            onClick={toggleModal}
                            >{props[0].botonCompartir}</p>
                        </div>
                    </div>
                </div>
            </div>

            <ShareModal open={isModalVisible} onClose={toggleModal} href={videoUrl} />
        </div>
    )
}

export default HeadboardVideo;
